<template>
    <button
        class="button-base"
        :class="getBemModifiers()"
        v-on="$listeners"
    >
        <!-- @slot Use this slot for the content of link -->
        <slot />
    </button>
</template>

<script>
export default {
    name: 'ButtonBase',
};
</script>
<style lang="scss">
    .button-base {
        $self: &;

        font: $font-weight-bold 17px/48px $goodHomeFontFamily;
        box-sizing: border-box;
        border: none;
        background: none;
        outline: none;
        display: inline-block;
        text-decoration: none;
        cursor: pointer;
        padding: 0 24px;
        margin: 12px 12px;
        height: 48px;
        min-width: 190px;
        text-align: center;

        &--white {
            background-color: $color-castoWhite;
            color: $color-castoBlue;
        }

        &--yellow {
            background-color: $color-castoYellow;
            color: $color-castoBlue;
        }

        &--blue {
            background-color: $color-castoBlue;
            color: $color-castoWhite;
        }

        &--red {
            background-color: $color-deepCanynon;
            color: $color-castoWhite;
        }

        &--gray {
            background-color: $color-slate70;
            color: $color-castoWhite;
        }

        &--link {
            color: $color-castoBlue;
            min-width: auto;
            padding: 0;
            height: auto;
            line-height: 1;
            margin: 0;
            font-weight: $font-weight-light;
        }

        &--custom {
            font: inherit;
            padding: initial;
            margin: 0;
            height: auto;
            min-width: auto;
            text-align: inherit;
        }

        &--horizontally-centered {
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
        }

        &--vertically-centered {
            align-items: center;
        }

        &--full-width {
            width: 100%;
        }

        &--color-inherit {
            color: inherit;
        }

        &--color-slate-70 {
            color: $color-slate70;
        }

        &--color-slate-100 {
            color: $color-slate100;
        }

        &--color-slate100-dark {
            color: $color-slate100-dark;
        }

        &--color-casto-blue {
            color: $color-castoBlue;
        }

        &--line-height-one {
            line-height: 1;
        }

        &--line-height-small {
            line-height: 36px;
        }

        &--line-height-big {
            line-height: 60px;
        }

        &--font-size-smallest {
            font-size: 12px;
        }

        &--font-size-smaller {
            font-size: 13px;
        }

        &--font-size-small {
            font-size: 14px;
        }

        &--font-size-normal {
            font-size: 15px;
        }

        &--font-size-large {
            font-size: 18px;
        }

        &--font-weight-light {
            font-weight: $font-weight-light;
        }

        &--font-weight-regular {
            font-weight: $font-weight-regular;
        }

        &--font-weight-bold {
            font-weight: $font-weight-bold;
        }

        &--hover-underlined:hover {
            text-decoration: underline;
        }

        &--background-casto-blue {
            color: $color-castoWhite;
            background-color: $color-castoBlue;

            &:hover {
                background-color: $color-castoBlue-dark;
            }
        }

        &--background-deep-canyon {
            background-color: $color-deepCanynon;

            &:hover {
                background-color: $color-deepCanynon-dark;
            }
        }

        &--background-slate-light {
            background: $color-slate50;

            &:hover {
                background-color: $color-slate50-dark;
            }
        }

        &--background-slate-medium {
            background: $color-slate70;

            &:hover {
                background-color: $color-slate70-dark;
            }
        }

        &--background-slate-dark {
            background: $color-slate100;

            &:hover {
                background-color: $color-slate100-dark;
            }
        }

        &--disabled {
            background-color: $color-slate10;
            cursor: default;

            &:hover {
                background: $color-slate10;
            }
        }

        &--justify-content-center {
            justify-content: center;
        }

        &--text {
            height: auto;
            min-width: auto;
            display: inline;
            padding: 0;
            margin: 0;
            line-height: inherit;
            text-align: inherit;

            &:not(#{$self}--disabled):hover {
                color: $color-castoBlue;
            }
        }

        &--text#{&}--disabled {
            color: $color-slate20-dark;
            background: none;
        }

        &--text#{&}--blue {
            color: $color-castoBlue;
            background: none;

            &:hover {
                color: $color-slate100-dark;
            }
        }
    }

@media (min-width: $mf-breakpoint-tablet) {
    .button-base {
        $self: &;

        &--desktop-color-slate-70:not(#{$self}--disabled) {
            color: $color-slate70;
        }
    }
}
</style>
